import type * as models from './models'

/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  /**
   * {@link State.Entry} for {@link models.Employee} representing the current
   * {@link user} in the current zone
   */
  employee?: State.Entry<models.Employee>
}
export namespace State {
  export const INITIAL: State = {}

  export type Entry<T> = ExactlyOneOf<{
    data?: T
    isLoading?: boolean
    error?: Error
  }>
}
